import axios from 'axios';
import store from "../store";
import router from "../router";
import { getAuthHeaders } from "./auth-headers";
import { env } from "./env";
import { shouldLogoutOnUnauthorized } from "./httpSessionOn401";

axios.defaults.baseURL = env('VUE_APP_BACKOFFICE_API', 'http://localhost:3033/');

export default class HttpClientV2 {

    constructor(api, params)
    {
        this.api = api;
        this.params = params;
    }

    error(error){
        if (shouldLogoutOnUnauthorized(error)) {
            store.dispatch('logout').then(() => {
                router.push({path: '/?expired=true'});
            });
        }
        throw error;
    }

    async getData(){
        const headers = await getAuthHeaders();
        let finalParams = {params: this.params ? this.params.params : "", responseType: 'blob', headers};
        try {
            return await axios.get(this.api, finalParams);
        } catch (error) {
            this.error(error)
        }
    }

    async postData(){
        const headers = await getAuthHeaders();
        let config = {responseType: 'arraybuffer', headers};

        try {
            return await axios.post(this.api, this.params, config);
        } catch (error) {
            this.error(error)
        }
    }

    async get(){
        const headers = await getAuthHeaders();
        let finalParams = {params: this.params ? this.params.params : "", headers};

        try {
            return await axios.get(this.api, finalParams);
        } catch (error) {
            this.error(error)
        }
    }

    async post(){
        const headers = await getAuthHeaders();
        const config = Object.keys(headers).length > 0 ? { headers } : {};

        try {
            return await axios.post(this.api, this.params, config);
        } catch (error) {
            this.error(error)
        }

    }

    async put() {
        const headers = await getAuthHeaders();
        const config = Object.keys(headers).length > 0 ? { headers } : {};

        try {
            return await axios.put(this.api, this.params, config);
        } catch (error) {
            this.error(error)
        }

    }

    async postMultipart() {
        const authHeaders = await getAuthHeaders();
        let config = {
            headers: {
                "Content-Type": "multipart/form-data",
                ...authHeaders,
            }
        };

        const bodyFormData = new FormData();
        for (const paramsKey in this.params) {
            bodyFormData.append(paramsKey, this.params[paramsKey])
        }

        try {
            return await axios.post(this.api, bodyFormData, config);
        } catch (error) {
            this.error(error)
        }

    }

    async delete() {
        const headers = await getAuthHeaders();
        const config = Object.keys(headers).length > 0 ? { headers } : {};
        if (this.params) {
            config.data = this.params;
        }

        try {
            return await axios.delete(this.api, config);
        } catch (error) {
            this.error(error)
        }

    }
}
